// 悟空优势
import React, { useContext } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import classNames from 'classnames';
import { PC, Mobile } from '@wukong/haomao';
import { MyContext } from '../../../../config/context-manager';

import Title from '../Title';
import styles from './style.module.scss';

const Advantage = () => {
  const { t } = useTranslation('chineseSpecialty');
  const { locale } = useContext(MyContext);
  return (
    <section
      className={classNames(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <PC>
        <div>
          <div className={styles.advantage}>
            <div className={styles.leftContentContainer}>
              <div className={styles.titleContainer}>
                <h3>{t('悟空优势-标题')}</h3>
                <p>{t('悟空优势-副标题')}</p>
              </div>
              <div className={styles.bannerImg}>
                <span className={styles.bannerIcon} />
                <Image
                  src="/images/chinese-math-class/chinese/specil/advantage-banner.png"
                  width={946}
                  height={534}
                  layout="responsive"
                  alt="悟空中文课程核心优势"
                />
              </div>
            </div>
            <div className={styles.rightContentContainer}>
              <div className={styles.advantageBg}>
                <Image
                  src="/images/chinese-math-class/chinese/specil/advantage-title-bg.png"
                  width={804}
                  height={740}
                  layout="responsive"
                  alt="悟空中文课程核心优势"
                />
              </div>
              <h4 className={styles.advantageTitle1}>{t('悟空优势-内容-1')}</h4>
              <h4 className={styles.advantageTitle2}>{t('悟空优势-内容-2')}</h4>
              <h4 className={styles.advantageTitle3}>{t('悟空优势-内容-3')}</h4>
              <h4 className={styles.advantageTitle4}>{t('悟空优势-内容-4')}</h4>
              <h4 className={styles.advantageTitle5}>{t('悟空优势-内容-5')}</h4>
              <h4 className={styles.advantageTitle6}>{t('悟空优势-内容-6')}</h4>
            </div>
          </div>
        </div>
      </PC>
      <Mobile>
        <div>
          <Title className={styles.teamTitle}>{t('悟空优势-标题')}</Title>
          <p className={styles.advantageDes}>{t('悟空优势-副标题')}</p>
          <div className={styles.positionRelative}>
            <div className={styles.advantageMobileImg}>
              <Image
                src="/images/chinese-math-class/chinese/specil/advantage-mobile-img.png"
                width={147}
                height={246}
                layout="responsive"
                alt="悟空中文课程核心优势"
              />
            </div>
            <div className={styles.advantageTagContainer}>
              <h4 className={classNames(styles.advantageTag, styles.pinkTag)}> {t('悟空优势-内容-1')} </h4>
              <h4 className={classNames(styles.advantageTag, styles.blueTag)}> {t('悟空优势-内容-移动端-1')} </h4>
              <h4 className={classNames(styles.advantageTag, styles.yellowTag)}> {t('悟空优势-内容-移动端-2')} </h4>
              <h4 className={classNames(styles.advantageTag, styles.pinkTag)}> {t('悟空优势-内容-移动端-3')} </h4>
              <h4 className={classNames(styles.advantageTag, styles.blueTag)}> {t('悟空优势-内容-移动端-4')} </h4>
              <h4 className={classNames(styles.advantageTag, styles.yellowTag)}> {t('悟空优势-内容-移动端-5')} </h4>
            </div>
          </div>
        </div>
      </Mobile>
    </section>
  );
};

export default Advantage;
